import { Component, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { CustomFieldEditorModalComponent } from 'src/app/shared/components/custom-field-editor-modal/custom-field-editor-modal.component';
import { ActivatedRoute } from '@angular/router';
import { FlatAttribute } from 'src/app/shared/models/attributes/flatAttribute';
import { Seat } from 'src/app/shared/models/team/seat';
import {
  GenericAttributeServiceFactory,
  IGenericAttributeService,
} from 'src/app/shared/services/genericAttributeServiceFactory.service';

@Component({
  selector: 'profile-custom-field-editor',
  templateUrl: './profile-custom-field-editor.component.html',
  styleUrls: ['./profile-custom-field-editor.component.scss'],
})
export class ProfileCustomFieldEditorComponent {
  public flatAttribute: FlatAttribute;
  private _customFieldValues: Attribute[];
  private _customField: AttributeDefinition;

  @Input()
  get customField(): AttributeDefinition {
    return this._customField;
  }
  set customField(value: AttributeDefinition) {
    this._customField = value;
    this.resetState();
  }
  @Input()
  get customFieldValues(): Attribute[] {
    return this._customFieldValues;
  }
  set customFieldValues(value: Attribute[]) {
    this._customFieldValues = value;
    this.resetState();
  }
  @Input()
  seat: Seat;

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private genericAttributeServiceFactory: GenericAttributeServiceFactory
  ) {}

  get firstElementValueListItem(): AttributeDefinitionValueListItem {
    return this._customFieldValues[0]?.attributeDefinitionValueListItem;
  }
  private resetState = () => {
    this.flatAttribute = this.customFieldValues?.length
      ? FlatAttribute.fromAttributes(this.customFieldValues)[0]
      : this.customField
      ? FlatAttribute.fromAttributeDefinition(this.customField)
      : null;
  };

  private buildGenericPersonAttributeService = (): IGenericAttributeService =>
    this.seat
      ? this.genericAttributeServiceFactory.BuildForTeamProfile(
          this.route.snapshot.params['teamId'],
          this._customField,
          this.seat
        )
      : this.genericAttributeServiceFactory.BuildForPersonOnProfile(
          this.route.snapshot.parent.params['personId'],
          this._customField
        );

  formatDisplayValue(attribute: Attribute): string {
    let displayValue = '';

    if (attribute && attribute.type === 'Date' && attribute.hasValue()) {
      displayValue = this.datePipe.transform(attribute.value, 'mediumDate');
    } else {
      displayValue = attribute.hasValue() ? attribute.value : '';
    }

    return displayValue;
  }

  @ViewChild(CustomFieldEditorModalComponent, { static: true })
  editAccountModulesComponent: CustomFieldEditorModalComponent;

  openEditAttributeModal() {
    this.editAccountModulesComponent.open(
      this.customFieldValues,
      this.buildGenericPersonAttributeService()
    );
  }

  public onClearField() {
    this.buildGenericPersonAttributeService().deleteAttribute();
  }
}
